import * as pubApi from "api/Knowledge";
import { RequestIndicator } from 'components/CallServer';
import { SystemRoles } from 'models/ApiEnums';
import { TopicSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import TopicAutoComplete from 'views/Topic/Components/TopicAutoComplete';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    topics: TopicSuggestionDto[];
    relativesTopics: TopicSuggestionDto[];
    deletedRelativesTopics: string[];
    findRelativesTopics: boolean;
    skipTopicAccessFor?: SystemRoles;
    label?: string;
    onChange: (topics: TopicSuggestionDto[], relatives: TopicSuggestionDto[], deletedRelatives: string[]) => void;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const TopicsAndMembersBox: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const [processing, setProcessing] = React.useState(false);
    const { topics, relativesTopics, deletedRelativesTopics, findRelativesTopics, skipTopicAccessFor } = props;

    return (
        <>
            <RequestIndicator open={processing} type="waiting" />

            <TopicAutoComplete
                autoFocus
                overModal
                skipTopicAccessCheckFor={skipTopicAccessFor}
                label={props.label || t("Views.Publication.Components.TopicsAndMembersBox.TopicAutoCompleteLabel")}
                placeholder={t("Views.Publication.Components.TopicsAndMembersBox.TopicAutoCompletePlaceholder")}
                selectedItems={topics}
                margin="normal"
                onChange={(newTopics) => {
                    if (findRelativesTopics) {
                        const nt = newTopics.map((v) => v.key);

                        setProcessing(true);
                        pubApi.getHierarchyTopicSuggestions(nt, deletedRelativesTopics)
                            .then((newRelativeTopics) => {
                                props.onChange(newTopics, newRelativeTopics, deletedRelativesTopics);
                            })
                            .finally(() => setProcessing(false));
                    }
                    else
                        props.onChange(newTopics, relativesTopics, deletedRelativesTopics);
                }}
            />

            {
                findRelativesTopics && relativesTopics != null && relativesTopics.length > 0 &&
                <TopicAutoComplete
                    overModal
                    allowAdd={false}
                    label={t("Views.Publication.Components.TopicsAndMembersBox.RelativeTopicAutoCompleteLabel")}
                    selectedItems={relativesTopics}
                    margin="normal"
                    alternateMethodAccessKey={null}
                    onChange={
                        (newRelativeTopics) => {
                            const newDeleteRelativesTopics: string[] = [];
                            if (newRelativeTopics.length == 0)
                                relativesTopics.map((v) => newDeleteRelativesTopics.push(v.key));
                            else {
                                relativesTopics.forEach((v) => {
                                    if (newRelativeTopics.findIndex(x => x.key == v.key) == -1) newDeleteRelativesTopics.push(v.key);
                                });
                            }

                            props.onChange(topics, newRelativeTopics, newDeleteRelativesTopics);
                        }
                    }
                />
            }
        </>
    );
};

export default TopicsAndMembersBox;  